import { Entity } from '@backstage/catalog-model';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { RequirePermission } from '@backstage/plugin-permission-react';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { keyVaultSecretListPermission } from '../permissions';

// "KV present" predicate. A Component carries its dependsOn relations as
// targetRef STRINGS (`resource:default/<name>-kv`), not full target entities —
// so the tab gate matches the `-kv` suffix convention iacActions.ts deterministically
// uses (KV resources are `<name>-kv`; storage `-storage`; db `-db`). The backend
// re-validates `spec.type === 'azure-key-vault'` authoritatively, so a false
// positive here just 404s server-side; the tab is only a UX hint. Exported for tests.
export function entityHasKeyVault(entity: Entity): boolean {
  return (
    entity.kind.toLowerCase() === 'component' &&
    (entity.relations ?? []).some(
      r =>
        r.type === 'dependsOn' && /^resource:[^/]+\/.+-kv$/.test(r.targetRef),
    )
  );
}

// "Key Vault Secrets" entity tab. EntityContentBlueprint's `filter` gates the
// tab's EntityLayout.Route `if:` — so the tab only appears on Components with a
// Key Vault assigned. Wrapped in RequirePermission (defense-in-depth on the
// coarse keyVault.* policy gate) so a user who can't list secrets gets a
// not-found page rather than the form.
export const keyVaultTab = EntityContentBlueprint.make({
  name: 'secrets',
  params: {
    path: '/key-vault',
    title: 'Key Vault Secrets',
    icon: <VpnKeyIcon />,
    filter: entityHasKeyVault,
    loader: () =>
      import('../components/KeyVaultTab').then(m => (
        <RequirePermission permission={keyVaultSecretListPermission}>
          <m.KeyVaultTab />
        </RequirePermission>
      )),
  },
});
